import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const CarRequest = {
  // Fetch filtered list of cars
  carFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getCarFilterSet}`, {
      withCredentials: true,
      params: {
        ownerId: values?.ownerId,
        isActive: values?.isActive,
      },
    }),

  // Fetch the list of all car
  carList: (ownerId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getCarList}?ownerId=${ownerId}`, // Send id directly in the URL
      {
        withCredentials: true,
      }
    ),
};

export default CarRequest;
